import { format as formatJSDate, FormatOptions } from 'date-fns'
import { enUS, ru } from 'date-fns/locale'
import { RUS_MONTHS, RUS_MONTHS_SHORT, strings } from 'shared/translations'
import { UnicodeDateFormat } from 'shared/types'
import { DATE_FORMAT_HYPHEN } from './unicodeDateFormat'

const getLocalize = () => {
  const localeString = strings.getLanguage()

  if (localeString === 'ru') {
    const customRuLocalize = {
      ...ru,
      localize: {
        ...ru.localize,
        month: (n: number, options?: { width?: string }) => {
          if (options?.width === 'abbreviated') return RUS_MONTHS_SHORT[n]

          return RUS_MONTHS[n]
        },
      },
    }

    return { locale: customRuLocalize }
  }

  return { locale: enUS }
}

const formatDate = (
  date: string | Date,
  format: UnicodeDateFormat = 'dd MMM yyyy',
  options?: FormatOptions,
) => formatJSDate(new Date(date), format, options)

export const formatDateClient = (
  date: string | Date,
  format: UnicodeDateFormat = 'dd MMM yyyy',
) => {
  const options = getLocalize()

  return formatDate(date, format, options)
}

export const formatDateServer = (date: string | Date) =>
  formatDate(date, DATE_FORMAT_HYPHEN)

export const formatDateTimeZone = (
  date: string | Date,
  format: UnicodeDateFormat = 'dd MMM yyyy',
  hoursOffset = 3,
) => {
  const options = getLocalize()
  const zonedTime = new Date(
    new Date(date).getTime() - hoursOffset * 60 * 60 * 1000,
  )

  return formatDate(zonedTime, format, options)
}
